import React, {useCallback, useMemo} from "react";
import {useFormContext, useWatch} from "react-hook-form";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ArrowIcon} from "@pg-design/icons-module";
import {IOption} from "@pg-design/select-module";
import {useUserDevice} from "@pg-mono/user-device";
import {IInteractiveRegion, InteractiveRegionsMapAdapter} from "@pg-rp/interactive-regions-map";

import {useLazyGetMapRegionsQuery} from "../../../../offer/map/api/get_map_region";
import {useLazyGetMapRegionDistrictsAndSurroundingsQuery} from "../../../../offer/map/api/get_map_region_districts_and_surroundings";
import {useGetRegionDetailListQuery} from "../../../../region/api/get_region_detail_list";
import {PreferencesNoMap} from "./PreferencesNoMap";

interface IProps {
    onActionButtonClick?: () => void;
}

export const PreferencesRegionMap = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const {setValue, getValues} = useFormContext();
    const regions = useWatch({name: "regionSelector"});
    const regionIds = useMemo(() => regions.map((region: IOption<number>) => region.value), [regions]);

    const {data} = useGetRegionDetailListQuery({regionIds}, {skip: !regionIds.length});
    const [getMainRegionLazy] = useLazyGetMapRegionsQuery();
    const [getDistrictsAndSurroundingsLazy] = useLazyGetMapRegionDistrictsAndSurroundingsQuery();

    const getMainRegion = (parentId: number) => {
        return getMainRegionLazy({region: parentId}, true)
            .unwrap()
            .then((response: {results: IInteractiveRegion[]}) => response?.results?.[0] || null);
    };

    const getDistrictsAndSurroundings = (parentId: number) => {
        return getDistrictsAndSurroundingsLazy({parent: parentId}, true)
            .unwrap()
            .then((response: {results: IInteractiveRegion[]}) => response?.results || null);
    };

    const onRegionAccept = useCallback(() => {
        setValue("regions", regions);
        props.onActionButtonClick?.();
    }, [regions]);

    const onRegionDecline = () => {
        setValue("regionSelector", getValues("regions"));
        props.onActionButtonClick?.();
    };

    return (
        <InteractiveRegionsMapAdapter
            selectedRegions={regionIds.length && data ? data : null}
            handleUpdateRegions={(regions) => {
                const convertedRegions = convertRegions(regions);
                setValue("regionSelector", convertedRegions);
            }}
            isInModal={!!isMobile}
            getMainRegion={getMainRegion}
            getDistrictsAndSurroundings={getDistrictsAndSurroundings}
            mapHeight={550}
            bottomControlsSlot={({handleSubmitRegions}) => {
                return (
                    <div className={mapButtonsWrapper}>
                        <Button variant="outlined_secondary" size="small" type="button" iconLeft={ArrowIcon} className={mapButton} onClick={onRegionDecline}>
                            Powróć
                        </Button>
                        <Button
                            variant="filled_primary"
                            size="small"
                            type="button"
                            className={mapButton}
                            onClick={() => {
                                handleSubmitRegions();
                                onRegionAccept();
                            }}
                        >
                            Zapisz lokalizację
                        </Button>
                    </div>
                );
            }}
            noMapElement={<PreferencesNoMap />}
        />
    );
};

const convertRegions = (regions: IInteractiveRegion[]) => {
    return regions.map((region) => ({value: region.id, label: region.short_name}));
};

const mapButtonsWrapper = css({
    display: "flex",
    flexDirection: "column-reverse",
    gap: 1,
    backgroundColor: "#fff",
    m: -3,
    px: 1.5,
    py: 1,

    md: {
        flexDirection: "row",
        gap: 2,
        m: "unset",
        p: "unset"
    }
});

const mapButton = css({
    width: "100%",

    md: {
        width: "50%"
    }
});
import React, {useCallback, useMemo} from "react";
import {useFormContext, useWatch} from "react-hook-form";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ArrowIcon} from "@pg-design/icons-module";
import {IOption} from "@pg-design/select-module";
import {useUserDevice} from "@pg-mono/user-device";
import {IInteractiveRegion, InteractiveRegionsMapAdapter} from "@pg-rp/interactive-regions-map";

import {useLazyGetMapRegionsQuery} from "../../../../offer/map/api/get_map_region";
import {useLazyGetMapRegionDistrictsAndSurroundingsQuery} from "../../../../offer/map/api/get_map_region_districts_and_surroundings";
import {useGetRegionDetailListQuery} from "../../../../region/api/get_region_detail_list";
import {PreferencesNoMap} from "./PreferencesNoMap";

interface IProps {
    onActionButtonClick?: () => void;
}

export const PreferencesRegionMap = (props: IProps) => {
    const {isMobile} = useUserDevice();
    const {setValue, getValues} = useFormContext();
    const regions = useWatch({name: "regionSelector"});
    const regionIds = useMemo(() => regions.map((region: IOption<number>) => region.value), [regions]);

    const {data} = useGetRegionDetailListQuery({regionIds}, {skip: !regionIds.length});
    const [getMainRegionLazy] = useLazyGetMapRegionsQuery();
    const [getDistrictsAndSurroundingsLazy] = useLazyGetMapRegionDistrictsAndSurroundingsQuery();

    const getMainRegion = (parentId: number) => {
        return getMainRegionLazy({region: parentId}, true)
            .unwrap()
            .then((response: {results: IInteractiveRegion[]}) => response?.results?.[0] || null);
    };

    const getDistrictsAndSurroundings = (parentId: number) => {
        return getDistrictsAndSurroundingsLazy({parent: parentId}, true)
            .unwrap()
            .then((response: {results: IInteractiveRegion[]}) => response?.results || null);
    };

    const onRegionAccept = useCallback(() => {
        setValue("regions", regions);
        props.onActionButtonClick?.();
    }, [regions]);

    const onRegionDecline = () => {
        setValue("regionSelector", getValues("regions"));
        props.onActionButtonClick?.();
    };

    return (
        <InteractiveRegionsMapAdapter
            selectedRegions={regionIds.length && data ? data : null}
            handleUpdateRegions={(regions) => {
                const convertedRegions = convertRegions(regions);
                setValue("regionSelector", convertedRegions);
            }}
            isInModal={!!isMobile}
            getMainRegion={getMainRegion}
            getDistrictsAndSurroundings={getDistrictsAndSurroundings}
            mapHeight={550}
            bottomControlsSlot={({handleSubmitRegions}) => {
                return (
                    <div className={mapButtonsWrapper}>
                        <Button variant="outlined_secondary" size="small" type="button" iconLeft={ArrowIcon} className={mapButton} onClick={onRegionDecline}>
                            Powróć
                        </Button>
                        <Button
                            variant="filled_primary"
                            size="small"
                            type="button"
                            className={mapButton}
                            onClick={() => {
                                handleSubmitRegions();
                                onRegionAccept();
                            }}
                        >
                            Zapisz lokalizację
                        </Button>
                    </div>
                );
            }}
            noMapElement={<PreferencesNoMap />}
        />
    );
};

const convertRegions = (regions: IInteractiveRegion[]) => {
    return regions.map((region) => ({value: region.id, label: region.short_name}));
};

const mapButtonsWrapper = css({
    display: "flex",
    flexDirection: "column-reverse",
    gap: 1,
    backgroundColor: "#fff",
    m: -3,
    px: 1.5,
    py: 1,

    md: {
        flexDirection: "row",
        gap: 2,
        m: "unset",
        p: "unset"
    }
});

const mapButton = css({
    width: "100%",

    md: {
        width: "50%"
    }
});
